import React, { useContext, useState, useEffect, useRef } from "react";
import { useForm, FormProvider } from "react-hook-form";
import FormInput from "../../../components/FormInput";
import { validationRules, validateDOB } from "../../../utils/validationRules";
import { AuthContext } from "../../../Context/AuthContext";
import {
  createHomeLoan,
  getAllCities,
  getAllStates,
  getAllPincode,
  getHomeLoanByEmail,
  getHomeLoanByMobile,
  getAllCompanies,
  getAllHomeLoanBanks,
  getBusinessLoanBankList,
  getDoctorLoanBankList,
  getPersonalLoanBankList,
  getNriLoanBankList,
  createOrGetCustomer
} from "../../../middleware/backend_hepler";
import { useNavigate } from "react-router-dom";
import { Stepper, Step, StepLabel } from "@mui/material";
import { Row, Col, Button } from "react-bootstrap";
import SelectInput from "../../../components/SelectInput";
import DropDownInput from "../../../components/DropDownInput";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../../../assets/logo.png";
import { FaTrashAlt, FaMinusCircle, FaPlusCircle } from "react-icons/fa";
import CreateCompanyModal from "../Company/CreateComapnyModal";


const CreateHomeForm = () => {
  const { adminId, adminName, isLoggedIn, adminRole } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [filteredStates, setFilteredStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [pincodenumber, setPincode] = useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [presentState, setPresentState] = useState(null);
  const [presentCityOptions, setPresentCityOptions] = useState([]);
  const [presentPincodeOptions, setPresentPincodeOptions] = useState([]);
  const [officeState, setOfficeState] = useState(null);
  const [officeCityOptions, setOfficeCityOptions] = useState([]);
  const [officePincodeOptions, setOfficePincodeOptions] = useState([]);
  const [clinicState, setClinicState] = useState(null);
  const [clinicCityOptions, setClinicCityOptions] = useState([]);
  const [clinicPincodeOptions, setClinicPincodeOptions] = useState([]);
  const [hospitalState, setHospitalState] = useState(null);
  const [hospitalCityOptions, setHospitalCityOptions] = useState([]);
  const [hospitalPincodeOptions, setHospitalPincodeOptions] = useState([]);
  const [companyLists, setCompanyLists] = useState([]);
  const [bankLists, setBankLists] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const [personalLoanBanks, setPersonalLoanBanks] = useState([]);
  const [nriLoanBanks, setNriLoanBanks] = useState([]);
  const [businessLoanBanks, setBusinessLoanBanks] = useState([]);
  const [doctorLoanBanks, setDoctorLoanBanks] = useState([]);
  const [files, setFiles] = useState({});
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [showDocuments, setShowDocuments] = useState(false);

  const fileRefs = {
    pan: useRef(null),
    aadhar: useRef(null),
    fmb_document: useRef(null),
    account_Statement: useRef(null),
    dtcp_document: useRef(null),
    parent_document: useRef(null),
    register_document: useRef(null),
    patta_chitta_doc: useRef(null),
    ec_document: useRef(null),
    panchayat_document: useRef(null),
    engineer_estimate_doc: useRef(null),
    gst_document: useRef(null),
    itr_document: useRef(null),
    msme_document: useRef(null),
    payslip: useRef(null),
    photo: useRef(null),
    others: useRef(null),
  };

  const methods = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const trimFileName = (fileName) => {
    return fileName.trim().replace(/\s+/g, "_");
  };

  const {
    handleSubmit,
    watch,
    trigger,
    setValue,
    formState: { errors, isValid },
  } = methods;
  const [mobileExists, setMobileExists] = useState(false);
  const [emailExists, setEmailExists] = useState(false);
  const email = watch("email");
  const mobile = watch("mobile");
  const dob = watch("dob");
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const steps = ["Personal Details", "Income Details", "Upload Documents"];

  const handleStepChange = async (newStep) => {
    if (newStep > activeStep) {
      const isValid = await trigger();
      if (isValid) {
        if (emailExists) {
          toast.error("Email already exists. Please use a different email.");
          return;
        }

        if (mobileExists) {
          toast.error(
            "Mobile number already exists. Please use a different mobile number."
          );
          return;
        }

        setActiveStep(newStep);
      }
    } else {
      setActiveStep(newStep);
    }
  };

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const statesData = await getAllStates();
        const availableStates = statesData.filter(
          (state) => state.availability === "Yes"
        );
        setFilteredStates(availableStates);
      } catch (error) {
        console.error("Ercror fetching states data:", error);
      }
    };
    fetchStates();
  }, []);

  const stateOptions = filteredStates.map((state) => ({
    value: state.name,
    label: state.name,
  }));

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const citiesData = await getAllCities();
        citiesData.sort((a, b) => a.name.localeCompare(b.name));
        setCities(citiesData);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };
    fetchCities();
  }, []);

  useEffect(() => {
    const fetchPinCode = async () => {
      try {
        const pincodeData = await getAllPincode();
        setPincode(pincodeData);
      } catch (error) {
        console.error("Error fetching pincodes:", error);
      }
    };
    fetchPinCode();
  }, []);

  useEffect(() => {
    if (!selectedState) {
      setCityOptions([]);
      setPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === selectedState
      );

      const cityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setCityOptions(cityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === selectedState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setPincodeOptions(uniqueOptions);
    }

    if (!presentState) {
      setPresentCityOptions([]);
      setPresentPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === presentState
      );

      const presentCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setPresentCityOptions(presentCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === presentState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setPresentPincodeOptions(uniqueOptions);
    }

    if (!officeState) {
      setOfficeCityOptions([]);
      setOfficePincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === officeState
      );

      const officeCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setOfficeCityOptions(officeCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === officeState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setOfficePincodeOptions(uniqueOptions);
    }

    if (!clinicState) {
      setClinicCityOptions([]);
      setClinicPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === clinicState
      );

      const clinicCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setClinicCityOptions(clinicCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === clinicState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setClinicPincodeOptions(uniqueOptions);
    }

    if (!hospitalState) {
      setHospitalCityOptions([]);
      setHospitalPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === hospitalState
      );

      const hospitalCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setHospitalCityOptions(hospitalCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === hospitalState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setHospitalPincodeOptions(uniqueOptions);
    }
  }, [
    selectedState,
    presentState,
    officeState,
    clinicState,
    hospitalState,
    cities,
    pincodenumber,
  ]);

  const fetchCompanies = async () => {
    try {
      const response = await getAllCompanies();
      const companyData = response.data.map((company) => ({
        value: company.company_id,
        label: company.company_name,
      }));
      companyData.sort((a, b) => a.label.localeCompare(b.label));
      setCompanyLists(companyData);
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  useEffect(() => {
    if (!selectedCompanyId) return;
    if (
      !selectedCompanyId ||
      (Array.isArray(selectedCompanyId) && selectedCompanyId.length === 0)
    ) return;
    const fetchCompanyByIdWithBanks = async () => {
      try {
        const response = await getAllHomeLoanBanks(selectedCompanyId);

        const bankList = response.data.bank_list;

        const formattedBanks = bankList.map((bank) => ({
          value: bank.bank_name,
          label: bank.bank_name,
        }));

        setBankLists(formattedBanks);
      } catch (error) {
        console.error("Error fetching bank:", error);
      }
    };

    fetchCompanyByIdWithBanks();
  }, [selectedCompanyId]);

  useEffect(() => {
    const fetchBusinessLoanBanks = async () => {
      try {
        const response = await getBusinessLoanBankList();
        const banksData = response.data.map(bank => ({
          value: bank.bank_name,
          label: bank.bank_name
        }));
        banksData.sort((a, b) => a.label.localeCompare(b.label));
        setBusinessLoanBanks(banksData);
      } catch (error) {
        console.error("Error fetching business loan banks:", error);
      }
    };
    fetchBusinessLoanBanks();
  }, []);

  useEffect(() => {
    const fetchPersonalLoanBanks = async () => {
      try {
        const response = await getPersonalLoanBankList();
        const banksData = response.data.map(bank => ({
          value: bank.bank_name,
          label: bank.bank_name
        }));
        banksData.sort((a, b) => a.label.localeCompare(b.label));
        setPersonalLoanBanks(banksData);
      } catch (error) {
        console.error("Error fetching personal loan banks:", error);
      }
    };
    fetchPersonalLoanBanks();
  }, []);

  useEffect(() => {
    const fetchNriLoanBanks = async () => {
      try {
        const response = await getNriLoanBankList();
        const banksData = response.data.map(bank => ({
          value: bank.bank_name,
          label: bank.bank_name
        }));
        banksData.sort((a, b) => a.label.localeCompare(b.label));
        setNriLoanBanks(banksData);
      } catch (error) {
        console.error("Error fetching nri loan banks:", error);
      }
    };
    fetchNriLoanBanks();
  }, []);

  useEffect(() => {
    const fetchDoctorLoanBanks = async () => {
      try {
        const response = await getDoctorLoanBankList();
        const banksData = response.data.map(bank => ({
          value: bank.bank_name,
          label: bank.bank_name
        }));
        banksData.sort((a, b) => a.label.localeCompare(b.label));
        setDoctorLoanBanks(banksData);
      } catch (error) {
        console.error("Error fetching doctor loan banks:", error);
      }
    };
    fetchDoctorLoanBanks();
  }, []);

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption?.value || null);
    setValue("state", selectedOption?.value || "");
  };

  const getSelectedStateValue = () => {
    return stateOptions.find((option) => option.value === selectedState);
  };

  const handlePresentStateChange = (selectedOption) => {
    setPresentState(selectedOption?.value || null);
    setValue("present_state", selectedOption?.value || "");
  };

  const getSelectedPresentStateValue = () => {
    return stateOptions.find((option) => option.value === presentState);
  };

  const handleOfficeStateChange = (selectedOption) => {
    setOfficeState(selectedOption?.value || null);
    setValue("office_state", selectedOption?.value || "");
  };

  const getSelectedOfficeStateValue = () => {
    return stateOptions.find((option) => option.value === officeState);
  };

  const handleClinicStateChange = (selectedOption) => {
    setClinicState(selectedOption?.value || null);
    setValue("clinic_state", selectedOption?.value || "");
  };

  const getSelectedClinicStateValue = () => {
    return stateOptions.find((option) => option.value === clinicState);
  };

  const handleHospitalStateChange = (selectedOption) => {
    setHospitalState(selectedOption?.value || null);
    setValue("hospital_state", selectedOption?.value || "");
  };

  const getSelectedHospitalStateValue = () => {
    return stateOptions.find((option) => option.value === hospitalState);
  };

  const handleCompanyChange = (selectedOption) => {
    setSelectedCompanyId(selectedOption.value || null);
    setCompanyName("company_name", selectedOption.label || "")
    setValue("company_name", selectedOption.label || "");
  };

  const getSelectedCompanyValue = () => {
    return companyLists.find((option) => option.label === companyName);
  };

  const handleFileChange = (event) => {
    const { name, files } = event.target;
    if (files.length > 0) {
      setFiles((prev) => ({
        ...prev,
        [name]: files.length > 0 ? files[0] : null,
      }));
      const trimmedFiles = Array.from(files).map((file) => {
        const newFileName = trimFileName(file.name);
        return new File([file], newFileName, { type: file.type });
      });
    }
  };

  const handleClearFile = (name) => {
    if (fileRefs[name] && fileRefs[name].current) {
      fileRefs[name].current.value = null;
      setFiles((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const checkEmail = async (email) => {
    if (email) {
      try {
        const data = await getHomeLoanByEmail(email);
        setEmailExists(Boolean(data));
      } catch (error) {
        setEmailExists(false);
      }
    }
  };

  const checkMobile = async (mobile) => {
    if (mobile) {
      try {
        const data = await getHomeLoanByMobile(mobile);
        setMobileExists(Boolean(data));
      } catch (error) {
        setMobileExists(false);
      }
    }
  };

  const handleCompanyButtonClick = () => {
    setIsViewModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsViewModalOpen(false);
  };


  const onSubmit = async (data) => {
    setLoading(true);
    const mobile = localStorage.getItem("verifiedMobile");
    const name = data.name;

    if (data.are_you === "SelfEmployed" || data.are_you === "Doctor") {
      data.company_name = "";
    }

    try {
      if (!isLoggedIn) {
        // Not logged in: create or get customer
        let adminId;
        let adminName = name;

        try {
          const customerResponse = await createOrGetCustomer({ mobile, name });
          adminId = customerResponse.adminId;
          adminName = customerResponse.name || name;
          // toast.info(customerResponse.isNew ? "Customer created successfully!" : "Customer already exists!");
        } catch (err) {
          throw err;
        }

        // Set created_by and created_id for the home loan
        data.created_by = adminName;
        data.created_id = adminId;
        data.status = data.status || "open";
        data.assigned_to = data.assigned_to || "";

      } else {
        data.created_by = adminName;
        data.created_id = adminId;
      }

      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        if (
          key === "pan" ||
          key === "aadhar" ||
          key === "account_Statement" ||
          key === "dtcp_document" ||
          key === "parent_document" ||
          key === "register_document" ||
          key === "fmb_document" ||
          key === "panchayat_document" ||
          key === "patta_chitta_doc" ||
          key === "engineer_estimate_doc" ||
          key === "ec_document" ||
          key === "gst_document" ||
          key === "itr_document" ||
          key === "msme_document" ||
          key === "payslip" ||
          key === "photo" ||
          key === "others"
        ) {
          formData.append(key, data[key][0]);
        } else {
          formData.append(key, data[key]);
        }
      });

      const response = await createHomeLoan(formData);
      toast.success("Home loan created successfully!");
      setTimeout(() => {
        navigate(isLoggedIn ? "/homeloanlist" : "/");
      }, 2000);
    } catch (error) {
      setLoading(false);
      const errorMessage = error.response?.data?.message;
      console.error("Error submitting home loan:", errorMessage || error);
      toast.error("Failed to submit loan application. Please try again.");
    }
  };

  useEffect(() => {
    if (dob) {
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();

      if (
        monthDifference < 0 ||
        (monthDifference === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      if (age >= 0) {
        setValue("age", age);
      } else {
        setValue("age", "");
      }
    }
  }, [dob, setValue]);

  React.useEffect(() => {
    if (email) {
      checkEmail(email);
    }
  }, [email]);

  React.useEffect(() => {
    if (mobile) {
      checkMobile(mobile);
    }
  }, [mobile]);

  const handleGoBack = () => {
    if (isLoggedIn) {
      navigate("/homeloanlist");
    } else {
      navigate("/");
    }
  };

  return (
    <div className="container">
      <div className="edit-back-icon">
        {activeStep === 0 && (
          <div className="edit-back-text" onClick={handleGoBack}>
            &lt; Go Back
          </div>
        )}
        <img src={logo} alt="Logo" className="form-logo" />
      </div>
      <h2 className="my-4">Home Loan</h2>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className="form-group">
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            className="stepper-container"
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div className="form-content">
            {activeStep === 0 && (
              <div className="sections personal-details-sections">
                <h4>Personal Details</h4>
                <Row>
                  <Col md={6}>
                    <FormInput
                      name="name"
                      label="Name"
                      registerOptions={validationRules.name}
                      error={errors.name?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="dob"
                      label="Date of Birth"
                      type="date"
                      registerOptions={{
                        required: "Date of Birth is required",
                        validate: validateDOB,
                      }}
                      error={errors.dob?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput name="age" label="Age" type="number" readOnly />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="mobile"
                      label="Mobile"
                      type="tel"
                      registerOptions={validationRules.mobile}
                      error={
                        mobileExists
                          ? "Mobile number already exists"
                          : errors.mobile?.message
                      }
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="email"
                      label="Email ID"
                      registerOptions={validationRules.email}
                      error={errors.email?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="mother_name"
                      label="Mother Name"
                      registerOptions={validationRules.fieldRequired(
                        "Mother Name"
                      )}
                      error={errors.name?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="father_name"
                      label="Father Name"
                      registerOptions={validationRules.fieldRequired(
                        "Father Name"
                      )}
                      error={errors.name?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <DropDownInput
                      name="marital_status"
                      label="Marital Status"
                      options={[
                        { value: "Single", label: "Single" },
                        { value: "Married", label: "Married" },
                        { value: "Divorced", label: "Divorced" },
                      ]}
                      registerOptions={{
                        required: "Status is required",
                        onChange: (e) => {
                          setValue("marital_status", e.target.value);
                        },
                      }}
                      error={errors.marital_status?.message}
                    />
                  </Col>

                  {watch("marital_status") === "Married" && (
                    <Col md={6}>
                      <FormInput
                        name="spouse_name"
                        label="Spouse Name"
                        registerOptions={validationRules.fieldRequired(
                          "Spouse Name"
                        )}
                        error={errors.spouse_name?.message}
                      />
                    </Col>
                  )}

                  <Col md={6}>
                    <DropDownInput
                      name="residence_type"
                      label="Residence Type"
                      options={[
                        {
                          value: "OwnedByMe/Spouse",
                          label: "OwnedByMe/Spouse",
                        },
                        {
                          value: "OwnedByMy/Parents",
                          label: "OwnedByMy/Parents",
                        },
                        { value: "Rent", label: "Rent" },
                        { value: "PG", label: "PG" },
                        { value: "Hostel", label: "Hostel" },
                        { value: "Bachelor", label: "Bachelor" },
                        { value: "Company_Provided", label: "Company Provide" },
                      ]}
                      registerOptions={{
                        required: "Residence type is required",
                      }}
                      error={errors.residence_type?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="address"
                      label="Present Staying Address"
                      registerOptions={{
                        required: "Present Address is required",
                      }}
                      error={errors.address?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="landmark"
                      label="Landmark"
                      type="text"
                      registerOptions={{ required: "Landmark is required" }}
                      error={errors.landmark?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      name="state"
                      label="State"
                      options={stateOptions}
                      value={getSelectedStateValue()}
                      onChange={handleStateChange}
                      registerOptions={{ required: "State is required" }}
                      error={errors.state?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      name="city"
                      label="City"
                      options={cityOptions}
                      registerOptions={{ required: "City is required" }}
                      error={errors.city?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      name="pincode"
                      label="Pincode"
                      options={pincodeOptions}
                      registerOptions={{ required: "Pincode is required" }}
                    />
                  </Col>
                  <Col md={6}>
                    <DropDownInput
                      name="present_address_adhaar"
                      label="Is your Present Address as per Aadhaar"
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      registerOptions={{
                        required: "This selection is required",
                      }}
                      error={errors.present_address_adhaar?.message}
                    />
                  </Col>

                  {watch("present_address_adhaar") === "No" && (
                    <>
                      <Col md={6}>
                        <FormInput
                          name="present_address"
                          label="Present Aadhaar Address"
                          registerOptions={{
                            required: "Address is required",
                          }}
                          error={errors.present_address?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="present_state"
                          label="State"
                          options={stateOptions}
                          value={getSelectedPresentStateValue()}
                          onChange={handlePresentStateChange}
                          registerOptions={{ required: "State is required" }}
                          error={errors.present_state?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="present_city"
                          label="Current City"
                          options={presentCityOptions}
                          registerOptions={{ required: "City is required" }}
                          error={errors.present_city?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="present_pincode"
                          label="Pincode"
                          options={presentPincodeOptions}
                          registerOptions={{ required: "Pincode is required" }}
                        />
                      </Col>
                      <Col md={6}>
                        <FormInput
                          name="present_landmark"
                          label="Present Landmark"
                          registerOptions={{ required: "Landmark is required" }}
                          error={errors.present_landmark?.message}
                        />
                      </Col>
                    </>
                  )}
                </Row>
              </div>
            )}

            {activeStep === 1 && (
              <div className="sections requested-loan-details-sections">
                <h4>Income Details</h4>
                <Row>
                  <Col md={6}>
                    <FormInput
                      name="required_loan_amount"
                      label="Required Loan Amount"
                      type="text"
                      registerOptions={validationRules.homeLoanAmount}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="existing_emi_amount"
                      label="Total Existing Emi"
                      type="text"
                      registerOptions={{
                        required: "This Existing EMI is required",
                        pattern: validationRules.validNumber.pattern,
                      }}
                      error={errors.existing_emi_amount?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <DropDownInput
                      name="are_you"
                      label="Are You?"
                      options={[
                        { value: "Salaried", label: "Salaried" },
                        { value: "SelfEmployed", label: "Self Employed" },
                        // { value: "Doctor", label: "Doctor" },
                        // { value: "Nri", label: "Nri" },
                      ]}
                      registerOptions={{ required: "Selection is required" }}
                      error={errors.are_you?.message}
                    />
                  </Col>

                  {(watch("are_you") === "Salaried" ||
                    watch("are_you") === "Nri") && (
                    <>
                      <Col md={6}>
                        <SelectInput
                          name="company_name"
                          label="Working Company Name"
                          options={companyLists}
                          value={getSelectedCompanyValue()}
                          onChange={handleCompanyChange}
                        />
                      </Col>
                      {watch("company_name") === "Others" && (
                        <Col md={6}>
                          <FormInput
                            name="others_company"
                            label="Other's Company Name"
                          />
                        </Col>
                      )}
                      {isLoggedIn && adminRole !==  "customer" &&
                        watch("are_you") === "Nri" &&
                        watch("company_name") === "Others" && (
                        <Col md={6}>
                          <SelectInput
                            name="bank_name"
                            label="Bank Name"
                            options={nriLoanBanks}
                          />
                        </Col>
                      )}
                      {isLoggedIn && adminRole !==  "customer" &&
                        watch("are_you") === "Salaried" &&
                        (watch("company_name") === "Others" || bankLists.length < 1) && (
                        <Col md={6}>
                          <SelectInput
                            name="bank_name"
                            label="Bank Name"
                            options={personalLoanBanks}
                          />
                        </Col>
                      )}
                      {isLoggedIn && adminRole !==  "customer" &&
                      (watch("company_name") !== "Others" && bankLists.length > 0) && (
                        <Col md={6}>
                          <SelectInput
                            name="bank_name"
                            label="Bank Name"
                            options={bankLists}
                          />
                        </Col>
                      )}
                    </>
                  )}

                  {(watch("are_you") === "Salaried" ||
                    watch("are_you") === "Doctor") && (
                    <>
                      <Col md={6}>
                        <FormInput
                          name="net_salary"
                          label="Net Salary"
                          type="text"
                          registerOptions={{
                            required: "Net salary is required",
                            pattern: validationRules.validNumber.pattern,
                          }}
                          error={errors.net_salary?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <DropDownInput
                          name="is_pf_deducted"
                          label="Are You Looking for Balance Transfer?"
                          options={[
                            { value: "Yes", label: "Yes" },
                            { value: "No", label: "No" },
                          ]}
                          registerOptions={{
                            required: "Selection is required",
                          }}
                          error={errors.is_pf_deducted?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <FormInput
                          name="total_experience"
                          label="Total Year of Experience"
                          registerOptions={{
                            required: "Total year of experience is required",
                          }}
                          error={errors.total_experience?.message}
                        />
                      </Col>
                    </>
                  )}

                  {watch("are_you") === "Salaried" && (
                    <>
                      <Col md={6}>
                        <DropDownInput
                          name="company_type"
                          label="Company Type"
                          options={[
                            {
                              value: "PrivateLimited",
                              label: "Private Limited",
                            },
                            { value: "PublicLimited", label: "Public Limited" },
                            { value: "State", label: "State" },
                            { value: "CentralGovt", label: "Central Govt" },
                            {
                              value: "Proprietorship",
                              label: "Proprietorship",
                            },
                            { value: "Partnership", label: "Partnership" },
                          ]}
                        />
                      </Col>
                      <Col md={6}>
                        <FormInput
                          name="type_your_designation"
                          label=" Type Your Designation"
                          registerOptions={{
                            required: "Type your designation is required",
                          }}
                        />
                      </Col>
                      <Col md={6}>
                        <FormInput
                          name="office_address"
                          label="Office Address"
                          registerOptions={{ required: "Enter Address" }}
                          error={errors.address?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <FormInput
                          name="office_landmark"
                          label="Office Landmark"
                          registerOptions={{
                            required: "Landmark is required",
                          }}
                          error={errors.office_landmark?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="office_state"
                          label="State"
                          value={getSelectedOfficeStateValue()}
                          onChange={handleOfficeStateChange}
                          options={stateOptions}
                          registerOptions={{ required: "State is required" }}
                          error={errors.office_state?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="office_city"
                          label="City"
                          options={officeCityOptions}
                          registerOptions={{ required: "City is required" }}
                          error={errors.office_city?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="office_pincode"
                          label="Pincode"
                          options={officePincodeOptions}
                          registerOptions={{
                            required: "Pincode is required",
                          }}
                          error={errors.office_pincode?.message}
                        />
                      </Col>
                    </>
                  )}

                  {watch("are_you") === "SelfEmployed" && (
                    <>
                    {isLoggedIn && adminRole !==  "customer" &&(
                      <Col md={6}>
                        <SelectInput
                          name="bank_name"
                          label="Bank Name"
                          options={businessLoanBanks}
                        />
                      </Col>
                     )}
                      <Col md={6}>
                        <DropDownInput
                          name="register_company"
                          label="Your Company Registered As"
                          options={[
                            {
                              value: "private_limited",
                              label: "Private Limited",
                            },
                            {
                              value: "proprietorship",
                              label: "Proprietorship",
                            },
                            { value: "partnership", label: "Partnership" },
                            { value: "llp", label: "LLP" },
                            {
                              value: "not_registered",
                              label: "NOT Registered",
                            },
                          ]}
                          registerOptions={{
                            required: "Selection is required",
                          }}
                        />
                      </Col>
                      <Col md={6}>
                        <FormInput
                          name="turnover"
                          label="Annual Turn Over"
                          type="text"
                          registerOptions={{
                            ...validationRules.turnover,
                            pattern: validationRules.validNumber.pattern,
                          }}
                                              />
                      </Col>
                      <Col md={6}>
                        <DropDownInput
                          name="business_type"
                          label="Nature of Business"
                          options={[
                            { value: "manufacturing", label: "Manufacturing" },
                            { value: "retails", label: "Retails" },
                            { value: "service", label: "Service" },
                            { value: "agriculture", label: "Agriculture" },
                            { value: "real_estate", label: "Real Estate" },
                            {
                              value: "transportation",
                              label: "Transportation",
                            },
                            { value: "e-Commerce", label: "E-Commerce" },
                            { value: "others", label: "Others" },
                          ]}
                          registerOptions={{
                            required: "Selection is required",
                          }}
                        />
                      </Col>
                      {watch("business_type") === "others" && (
                        <Col md={6}>
                          <FormInput
                            name="description"
                            label="Others"
                            registerOptions={{
                              required: "Others is required",
                            }}
                          />
                        </Col>
                      )}

                      <Col md={6}>
                        <DropDownInput
                          name="business_place"
                          label="Business Place"
                          options={[
                            { value: "Own", label: "Own" },
                            { value: "Rent", label: "Rent" },
                            { value: "lease", label: "Lease" },
                          ]}
                          registerOptions={{
                            required: "Selection is required",
                          }}
                        />
                      </Col>

                      {watch("business_place") === "Own" && (
                        <>
                          <Col md={6}>
                            <FormInput
                              name="businessStart_year"
                              label="Business Start Year"
                              type="text"
                              registerOptions={{
                                required: "Business Start Year is required",
                                pattern: validationRules.validNumber.pattern,
                              }}
                            />
                          </Col>

                          <Col md={6}>
                            <DropDownInput
                              name="gst_registered"
                              label="GST Registered"
                              options={[
                                { value: "Yes", label: "Yes" },
                                { value: "No", label: "No" },
                              ]}
                              registerOptions={{
                                required: "Selection is required",
                              }}
                            />
                          </Col>
                          {watch("gst_registered") === "Yes" && (
                            <Col md={6}>
                              <FormInput
                                name="gst_registerd_year"
                                label="GST Registered Year"
                                type="text"
                                registerOptions={{
                                  required: "GST Registered Year is required",
                                  pattern: validationRules.validNumber.pattern,
                                  validate: {
                                    notFuture: (value) => {
                                      const currentYear =
                                        new Date().getFullYear();
                                      return (
                                        value <= currentYear ||
                                        "Year cannot be in the future"
                                      );
                                    },
                                  },
                                }}
                              />
                            </Col>
                          )}
                          <Col md={6}>
                            <DropDownInput
                              name="msme_registered"
                              label="MSME Registers"
                              options={[
                                { value: "Yes", label: "Yes" },
                                { value: "No", label: "No" },
                              ]}
                              registerOptions={{
                                required: "Selection is required",
                              }}
                            />
                          </Col>
                          <Col md={6}>
                            <DropDownInput
                              name="filling_itr"
                              label="Are You Filling ITR?"
                              options={[
                                { value: "Yes", label: "Yes" },
                                { value: "No", label: "No" },
                              ]}
                              registerOptions={{
                                required: "Selection is required",
                              }}
                            />
                          </Col>
                        </>
                      )}
                    </>
                  )}

                  {watch("are_you") === "Doctor" && (
                    <>
                      {isLoggedIn && adminRole !==  "customer" &&(
                        <Col md={6}>
                          <SelectInput
                            name="bank_name"
                            label="Bank Name"
                            options={doctorLoanBanks}
                          />
                        </Col>
                      )}
                      <Col md={6}>
                        <DropDownInput
                          name="degree"
                          label="Choose Degree"
                          options={[
                            { value: "MBBS", label: "MBBS" },
                            { value: "MD&Above", label: "MD & Above" },
                            { value: "Surgeon", label: "Surgeon" },
                            { value: "BDS/MDS", label: "BDS/MDS" },
                            { value: "Others", label: "Others" },
                          ]}
                          registerOptions={{
                            required: "This selection is required",
                          }}
                          error={errors.degree?.message}
                        />
                      </Col>
                      {watch("degree") === "MBBS" && (
                        <>
                          <Col md={6}>
                            <FormInput
                              name="mbbs_completed_year"
                              label="MBBS Completed Year"
                              type="text"
                              registerOptions={{
                                required: "MBBS Completed Year is required",
                                pattern: validationRules.validNumber.pattern,
                                validate: (value) => {
                                  const currentYear = new Date().getFullYear();
                                  if (
                                    isNaN(value) ||
                                    value < 1990 ||
                                    value >= currentYear
                                  ) {
                                    return `Please enter a year between 1990 and ${
                                      currentYear - 1
                                    }`;
                                  }
                                  return true;
                                },
                              }}
                              error={errors.mbbs_completed_year?.message}
                            />
                          </Col>
                        </>
                      )}
                      {watch("degree") === "Others" && (
                        <Col md={6}>
                          <FormInput
                            name="degree_others"
                            label="Degree Others"
                            registerOptions={{
                              required: "Degree others is required",
                            }}
                            error={errors.degree_others?.message}
                          />
                        </Col>
                      )}
                      <Col md={6}>
                        <DropDownInput
                          name="work_type"
                          label="Work Type?"
                          options={[
                            { value: "Salaried", label: "Salaried" },
                            { value: "Own Clinic", label: "Own Clinic" },
                          ]}
                          registerOptions={{
                            required: "This selection is required",
                          }}
                          error={errors.work_type?.message}
                        />
                      </Col>
                      {watch("work_type") === "Own Clinic" && (
                        <>
                          <Col md={6}>
                            <FormInput
                              name="service_experience"
                              label="Service Experience"
                              registerOptions={{
                                required: "Service experience is required",
                              }}
                              error={errors.service_experience?.message}
                            />
                          </Col>
                          <Col md={6}>
                            <FormInput
                              name="clinic_name"
                              label="Clinic Name"
                              registerOptions={{
                                required: "Clinic name is required",
                              }}
                              error={errors.clinic_name?.message}
                            />
                          </Col>
                          <Col md={6}>
                            <FormInput
                              name="clinic_address"
                              label="Clinic Address"
                              registerOptions={{
                                required: "Clinic addres is required",
                              }}
                              error={errors.clinic_address?.message}
                            />
                          </Col>
                          <Col md={6}>
                            <SelectInput
                              name="clinic_state"
                              label="Clinic State"
                              options={stateOptions}
                              value={getSelectedClinicStateValue()}
                              onChange={handleClinicStateChange}
                              registerOptions={{
                                required: "State is required",
                              }}
                              error={errors.clinic_state?.message}
                            />
                          </Col>
                          <Col md={6}>
                            <SelectInput
                              name="clinic_city"
                              label="Clinic City"
                              options={clinicCityOptions}
                              registerOptions={{ required: "City is required" }}
                              error={errors.clinic_city?.message}
                            />
                          </Col>
                          <Col md={6}>
                            <SelectInput
                              name="clinic_pincode"
                              label="Clinic Pincode"
                              options={clinicPincodeOptions}
                              registerOptions={{
                                required: "Pincode is required",
                              }}
                              error={errors.clinic_pincode?.message}
                            />
                          </Col>
                        </>
                      )}
                      {watch("work_type") === "Salaried" && (
                        <>
                          <Col md={6}>
                            <FormInput
                              name="hospital_name"
                              label="Working Hospital Name"
                              registerOptions={{
                                required: "Hospital name is required",
                              }}
                              error={errors.hospital_name?.message}
                            />
                          </Col>
                          <Col md={6}>
                            <FormInput
                              name="hospital_address"
                              label="Hospital Address"
                              registerOptions={{
                                required: "Hospital address is required",
                              }}
                              error={errors.hospital_address?.message}
                            />
                          </Col>
                          <Col md={6}>
                            <SelectInput
                              name="hospital_state"
                              label="Hospital State"
                              options={stateOptions}
                              value={getSelectedHospitalStateValue()}
                              onChange={handleHospitalStateChange}
                              registerOptions={{
                                required: "State is required",
                              }}
                              error={errors.clinic_state?.message}
                            />
                          </Col>
                          <Col md={6}>
                            <SelectInput
                              name="hospital_city"
                              label="Hospital City"
                              options={hospitalCityOptions}
                              registerOptions={{ required: "City is required" }}
                              error={errors.hospital_city?.message}
                            />
                          </Col>
                          <Col md={6}>
                            <SelectInput
                              name="hospital_pincode"
                              label="Hospital Pincode"
                              options={hospitalPincodeOptions}
                              registerOptions={{
                                required: "Pincode is required",
                              }}
                              error={errors.hospital_pincode?.message}
                            />
                          </Col>
                        </>
                      )}
                    </>
                  )}

                  {watch("are_you") === "Nri" && (
                    <>
                      <Col md={6}>
                        <FormInput
                          name="working_country"
                          label="Working Country"
                          registerOptions={{
                            required: "Working country is required",
                          }}
                          error={errors.working_country?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <FormInput
                          name="net_salary_indian_rupees"
                          label="Net salary in Indian Rupees"
                          type="text"
                          registerOptions={{
                            required: "Net salary is required",
                            pattern: validationRules.validNumber.pattern,
                          }}
                          error={errors.net_salary_indian_rupees?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <DropDownInput
                          name="present_india"
                          label="Are You Present in India?"
                          options={[
                            { value: "Yes", label: "Yes" },
                            { value: "No", label: "No" },
                          ]}
                          registerOptions={{
                            required: "Selection is required",
                          }}
                        />
                      </Col>
                    </>
                  )}

                  <Col md={6}>
                    <DropDownInput
                      name="add_reference"
                      label="Add Reference"
                      options={[
                        { value: "Colleague", label: "Colleague" },
                        { value: "Relative", label: "Relative" },
                      ]}
                    />
                  </Col>
                  <h4>Reference Details</h4>
                  <Col md={6}>
                    <FormInput name="reference_name" label="Name" />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="reference_mobile"
                      label="Mobile"
                      type="tel"
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput name="reference_address" label="Address" />
                  </Col>
                  <Col md={6}>
                    <FormInput name="reference_location" label="Location" />
                  </Col>
                </Row>
              </div>
            )}

            {activeStep === 2 && (
              <div className="sections financial-details-sections">
                <h4>Please Upload Clear Copy</h4>
                <div className="form-row">
                  <div className="sections document-upload-sections">
                    {(watch("are_you") === "Salaried" ||
                      watch("are_you") === "SelfEmployed") && (
                      <>
                        <div className="document-upload-group create-document">
                          <div className="document-label-container">
                            <label
                              htmlFor="photo"
                              className="document-label required"
                            >
                              Photo <br/> (Selfie Recommend)

                            </label>
                          </div>
                          <div className="document-file-container">
                            <input
                              type="file"
                              id="photo"
                              name="photo"
                              className="form-control-file"
                              {...methods.register("photo", {
                                required: "Photo is required",
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("photo").ref(e);
                                fileRefs.photo.current = e;
                              }}
                            />
                            {files.photo && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("photo")}
                              />
                            )}
                          </div>
                          {errors.photo && (
                            <span className="error-message">
                              {errors.photo.message}
                            </span>
                          )}
                        </div>
                        <div className="document-upload-group create-document">
                          <div className="document-label-container">
                            <label
                              htmlFor="aadhar"
                              className="document-label required"
                            >
                              Aadhaar/eAadhaar
                            </label>
                          </div>
                          <div className="document-file-container">
                            <input
                              type="file"
                              id="aadhar"
                              name="aadhar"
                              className="form-control-file"
                              {...methods.register("aadhar", {
                                required: "Aadhaar Card is required",
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("aadhar").ref(e);
                                fileRefs.aadhar.current = e;
                              }}
                            />
                            {files.aadhar && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("aadhar")}
                              />
                            )}
                          </div>
                          {errors.aadhar && (
                            <span className="error-message">
                              {errors.aadhar.message}
                            </span>
                          )}
                        </div>
                        <div className="document-upload-group create-document">
                          <div className="document-label-container">
                            <label
                              htmlFor="pan"
                              className="document-label required"
                            >
                              PAN Card
                            </label>
                          </div>
                          <div className="document-file-container">
                            <input
                              id="pan"
                              name="pan"
                              type="file"
                              className="form-control-file"
                              {...methods.register("pan", {
                                required: "PAN Card is required",
                                onChange: (e) => handleFileChange(e), // merge your custom onChange
                              })}
                              ref={(e) => {
                                methods.register("pan").ref(e); // react-hook-form ref
                                fileRefs.pan.current = e;
                              }}
                            />
                            {files.pan && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("pan")}
                              />
                            )}
                          </div>
                          {errors.pan && (
                            <span className="error-message">
                              {errors.pan.message}
                            </span>
                          )}
                        </div>
                        <div className="document-upload-group create-document">
                          <div className="document-label-container">
                            <label
                              htmlFor="account_Statement"
                              className="document-label required"
                            >
                              {watch("are_you") === "Salaried" ? (
                                <>
                                  Account Statement <br /> (Last 6 Months)
                                </>
                              ) : (
                                <>
                                  Account Statement <br /> (Last 12 Months)
                                </>
                              )}
                            </label>
                          </div>
                          <div className="document-file-container">
                            <input
                              name="account_Statement"
                              type="file"
                              id="account_Statement"
                              className="form-control-file"
                              accept=".pdf"
                              {...methods.register("account_Statement", {
                                required: "Account statement is required",
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("account_Statement").ref(e);
                                fileRefs.account_Statement.current = e;
                              }}
                            />
                            {files.account_Statement && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() =>
                                  handleClearFile("account_Statement")
                                }
                              />
                            )}
                          </div>
                          <span className="file-upload-message">
                            Upload only PDF files & without password
                          </span>
                          {errors.account_Statement && (
                            <span className="error-message">
                              {errors.account_Statement.message}
                            </span>
                          )}
                        </div>
                      </>
                    )}
                    {(watch("are_you") === "SelfEmployed") && (
                      <>
                        <div className="document-upload-group create-document">
                          <div className="document-label-container">
                            <label
                              htmlFor="gst_document"
                              className="document-label"
                            >
                              GST Registration or Any
                            </label>
                          </div>
                          <div className="document-file-container">
                            <input
                              type="file"
                              id="gst_document"
                              name="gst_document"
                              className="form-control-file"
                              onChange={handleFileChange}
                              {...methods.register("gst_document", {
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("gst_document").ref(e);
                                fileRefs.gst_document.current = e;
                              }}
                            />
                            {files.gst_document && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() =>
                                  handleClearFile("gst_document")
                                }
                              />
                            )}
                          </div>
                        </div>
                        <div className="document-upload-group create-document">
                          <div className="document-label-container">
                            <label
                              htmlFor="msme_document"
                              className="document-label"
                            >
                              GST 3B <br /> (Last 18 Months) 
                            </label>
                          </div>
                          <div className="document-file-container">
                            <input
                              type="file"
                              id="msme_document"
                              name="msme_document"
                              className="form-control-file"
                              onChange={handleFileChange}
                              {...methods.register("msme_document", {
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("msme_document").ref(e);
                                fileRefs.msme_document.current = e;
                              }}
                            />
                            {files.msme_document && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() =>
                                  handleClearFile("msme_document")
                                }
                              />
                            )}
                          </div>
                        </div>
                        <div className="document-upload-group create-document">
                          <div className="document-label-container">
                            <label
                              htmlFor="itr_document"
                              className="document-label"
                            >
                              ITR 
                            </label>
                          </div>
                          <div className="document-file-container">
                            <input
                              type="file"
                              id="itr_document"
                              name="itr_document"
                              className="form-control-file"
                              onChange={handleFileChange}
                              {...methods.register("itr_document", {
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("itr_document").ref(e);
                                fileRefs.itr_document.current = e;
                              }}
                            />
                            {files.itr_document && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() =>
                                  handleClearFile("itr_document")
                                }
                              />
                            )}
                          </div>
                        </div>
                        <div className="document-upload-group create-document">
                          <label htmlFor="others" className="document-label">
                            Others
                          </label>
                          <div className="document-file-container">
                            <input
                              id="others"
                              name="others"
                              type="file"
                              className="form-control-file"
                              {...methods.register("others", {
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("others").ref(e);
                                fileRefs.others.current = e;
                              }}
                            />
                            {files.others && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("others")}
                              />
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    {(watch("are_you") === "Salaried") && (
                      <>
                        <div className="document-upload-group create-document">
                          <div className="document-label-container">
                            <label
                              htmlFor="payslip"
                              className="document-label"
                            >
                              Payslip (Last 3 Months)
                            </label>
                          </div>
                          <div className="document-file-container">
                            <input
                              type="file"
                              id="payslip"
                              name="payslip"
                              className="form-control-file"
                              onChange={handleFileChange}
                              {...methods.register("payslip", {
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("payslip").ref(e);
                                fileRefs.payslip.current = e;
                              }}
                            />
                            {files.payslip && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() =>
                                  handleClearFile("payslip")
                                }
                              />
                            )}
                          </div>
                        </div>
                        <div className="document-upload-group create-document">
                          <label htmlFor="others" className="document-label">
                            Others
                          </label>
                          <Col md={12} className="document-dropdown-file">
                            <DropDownInput
                              name="other"
                              options={[
                                { value: "Employee ID", label: "Employee ID" },
                                { value: "Form16", label: "Form 16" },
                                { value: "Form26AS", label: "Form 26 AS" },
                                {
                                  value: "Previous Loan Statement",
                                  label: "Previous Loan Statement",
                                },
                              ]}
                            />
                          </Col>
                          <div className="document-file-container">
                            <input
                              id="others"
                              name="others"
                              type="file"
                              className="form-control-file"
                              {...methods.register("others", {
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("others").ref(e);
                                fileRefs.others.current = e;
                              }}
                            />
                            {files.others && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("others")}
                              />
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    <div>
                      <h4
                        className="pricing-content-subtitle pricing-dropdown-btn"
                        style={{ marginTop: "-10px" }}
                        onClick={() => setShowDocuments(!showDocuments)}
                      >
                        <span className="pricing-icon">
                          Upload Property Documents
                        </span>
                        {showDocuments ? <FaMinusCircle /> : <FaPlusCircle />} 
                      </h4>
                    </div>
                    {showDocuments && (
                      <div className="document-upload-sections">
                        <div className="document-upload-group create-document">
                          <div className="document-label-container">
                            <label
                              htmlFor="dtcp_document"
                              className="document-label"
                            >
                              Dtcp Document
                            </label>
                          </div>
                          <div className="document-file-container">
                            <input
                              type="file"
                              id="dtcp_document"
                              name="dtcp_document"
                              className="form-control-file"
                              {...methods.register("dtcp_document", {
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("dtcp_document").ref(e);
                                fileRefs.dtcp_document.current = e;
                              }}
                            />
                            {files.dtcp_document && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("dtcp_document")}
                              />
                            )}
                          </div>
                        </div>
                        <div className="document-upload-group create-document">
                          <div className="document-label-container">
                            <label
                              htmlFor="panchayat_document"
                              className="document-label"
                            >
                              Panchayat Document
                            </label>
                          </div>
                          <div className="document-file-container">
                            <input
                              type="file"
                              id="panchayat_document"
                              name="panchayat_document"
                              className="form-control-file"
                              {...methods.register("panchayat_document", {
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("panchayat_document").ref(e);
                                fileRefs.panchayat_document.current = e;
                              }}
                            />
                            {files.panchayat_document && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() =>
                                  handleClearFile("panchayat_document")
                                }
                              />
                            )}
                          </div>
                        </div>
                        <div className="document-upload-group create-document">
                          <div className="document-label-container">
                            <label
                              htmlFor="parent_document"
                              className="document-label"
                            >
                              Parent Document
                            </label>
                          </div>
                          <div className="document-file-container">
                            <input
                              type="file"
                              id="parent_document"
                              name="parent_document"
                              className="form-control-file"
                              {...methods.register("parent_document", {
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("parent_document").ref(e);
                                fileRefs.parent_document.current = e;
                              }}
                            />
                            {files.parent_document && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("parent_document")}
                              />
                            )}
                          </div>
                        </div>
                        <div className="document-upload-group create-document">
                          <div className="document-label-container">
                            <label
                              htmlFor="register_document"
                              className="document-label"
                            >
                              Register Document
                            </label>
                          </div>
                          <div className="document-file-container">
                            <input
                              type="file"
                              id="register_document"
                              name="register_document"
                              className="form-control-file"
                              {...methods.register("register_document", {
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("register_document").ref(e);
                                fileRefs.register_document.current = e;
                              }}
                            />
                            {files.register_document && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("register_document")}
                              />
                            )}
                          </div>
                        </div>
                        <div className="document-upload-group create-document">
                          <div className="document-label-container">
                            <label
                              htmlFor="fmb_document"
                              className="document-label"
                            >
                              FMB Document
                            </label>
                          </div>
                          <div className="document-file-container">
                            <input
                              type="file"
                              id="fmb_document"
                              name="fmb_document"
                              className="form-control-file"
                              {...methods.register("fmb_document", {
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("fmb_document").ref(e);
                                fileRefs.fmb_document.current = e;
                              }}
                            />
                            {files.fmb_document && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("fmb_document")}
                              />
                            )}
                          </div>
                        </div>
                        <div className="document-upload-group create-document">
                          <div className="document-label-container">
                            <label
                              htmlFor="patta_chitta_doc"
                              className="document-label"
                            >
                              Patta/Chitta Document
                            </label>
                          </div>
                          <div className="document-file-container">
                            <input
                              type="file"
                              id="patta_chitta_doc"
                              name="patta_chitta_doc"
                              className="form-control-file"
                              {...methods.register("patta_chitta_doc", {
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("patta_chitta_doc").ref(e);
                                fileRefs.patta_chitta_doc.current = e;
                              }}
                            />
                            {files.patta_chitta_doc && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("patta_chitta_doc")}
                              />
                            )}
                          </div>
                        </div>
                        <div className="document-upload-group create-document">
                          <div className="document-label-container">
                            <label
                              htmlFor="ec_document"
                              className="document-label"
                            >
                              EC Recent Document
                            </label>
                          </div>
                          <div className="document-file-container">
                            <input
                              type="file"
                              id="ec_document"
                              name="ec_document"
                              className="form-control-file"
                              {...methods.register("ec_document", {
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("ec_document").ref(e);
                                fileRefs.ec_document.current = e;
                              }}
                            />
                            {files.ec_document && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("ec_document")}
                              />
                            )}
                          </div>
                        </div>
                        <div className="document-upload-group create-document">
                          <div className="document-label-container">
                            <label
                              htmlFor="engineer_estimate_doc"
                              className="document-label"
                            >
                              Engineer Estimate / Validation <br /> Document
                            </label>
                          </div>
                          <div className="document-file-container">
                            <input
                              type="file"
                              id="engineer_estimate_doc"
                              name="engineer_estimate_doc"
                              className="form-control-file"
                              onChange={handleFileChange}
                              {...methods.register("engineer_estimate_doc", {
                                onChange: (e) => handleFileChange(e),
                              })}
                              ref={(e) => {
                                methods.register("engineer_estimate_doc").ref(e);
                                fileRefs.engineer_estimate_doc.current = e;
                              }}
                            />
                            {files.engineer_estimate_doc && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() =>
                                  handleClearFile("engineer_estimate_doc")
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="button-container">
            <Row className="mt-4">
              <Col className="text-end">
                {activeStep > 0 && (
                  <Button
                    variant="secondary"
                    onClick={() => handleStepChange(activeStep - 1)}
                    className="custom-back-button"
                  >
                    Go Back
                  </Button>
                )}
                {activeStep < steps.length - 1 && (
                  <Button
                    variant="primary"
                    onClick={() => handleStepChange(activeStep + 1)}
                    className="custom-next-button"
                  >
                    Next Step
                  </Button>
                )}
                {activeStep === steps.length - 1 && (
                  <Button
                    type="submit"
                    variant="primary"
                    className="custom-submit-button"
                  >
                    {loading ? "Processing..." : "Submit"}
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </form>
      </FormProvider>
      <CreateCompanyModal           
        isOpen={isViewModalOpen}
        onClose={handleCloseModal}
        onCompanyCreated={fetchCompanies} 
      />
      <ToastContainer />
    </div>
  );
};

export default CreateHomeForm;
